import axios from 'axios';
import { createController } from './requestManager';

const api = axios.create();

// Adiciona abort controller
api.interceptors.request.use(config => {
    const controller = createController();

    config.signal = controller.signal;

    return config;
});

// Trata cancelamentos globalmente
api.interceptors.response.use(
    response => response,
    error => {

        // Ignora requests canceladas
        if (error.code === 'ERR_CANCELED') {
            return new Promise(() => {});
        }

        return Promise.reject(error);
    }
);

export default api;
